import { Poll } from '../../../../../../db/polls/types';
import { getIsPollOpen } from '../../../helpers';

export function getCanSeeResults(poll: Poll | null) {
  if (!poll) return false;

  const canSeeResultsBeforeDeadline = !poll.preferences.deadlineFirst;
  const isPollOpen = getIsPollOpen(poll);

  if (!canSeeResultsBeforeDeadline && isPollOpen) return false;

  return true;
}
